import React, { useEffect, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Box, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { updateSection } from "../../../store/Profiles/profilesSlice";
import StepTransportation from "./StepTransportation";
import StepInsurance from "./StepInsurance";

const StepInsuranceTrans = ({ onBack, onNext }) => {
  const storedData = useSelector(state => state.profiles);

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [insuranceTranspor, setInsuranceTranspor] = useState({
    Transportation: [], // Lista de hospitalizaciones
    Insurance: {}, // Servicios seleccionados en TableDomesticViolence
  });

    useEffect(() => {
        setInsuranceTranspor(() => ({
            ...storedData
        }));
    }, [storedData]);

  const updateInsuranceTranspor = (data) => {
    setInsuranceTranspor((prev) => ({ ...prev, ...data }));
  };

  const handleNextStep = async () => {
    await handleSaveData(); // 🔹 Espera que termine antes de seguir
    onNext();
};

const handleSaveData = async () => {
  dispatch(updateSection({ section: "Transportation", data: { Transportation:insuranceTranspor.Transportation } }));
  dispatch(updateSection({ section: "Insurance", data: { Insurance:insuranceTranspor.Insurance } }));
}

  return (
    <div>
      <StepTransportation updateInsuranceTranspor={updateInsuranceTranspor} />
      <StepInsurance updateInsuranceTranspor={updateInsuranceTranspor} />
      
      
      {/* Botones */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
          <Button startIcon={<ArrowBackIcon />} onClick={onBack} variant="outlined">
              {t("common.back")}
          </Button>
          <Button endIcon={<ArrowForwardIcon />} onClick={handleNextStep} variant="contained" color="primary">
              {t("common.next")}
          </Button>
      </Box>
    </div>
  );
};

export default StepInsuranceTrans;
